import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconPrivacyTip.tsx
const OutlinedFilledPrivacyTip = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M444-280h72v-263h-72v263Zm36-311q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm-.06 536Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z" })
});
const OutlinedPrivacyTip = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M444-280h72v-263h-72v263Zm36-311q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm-.06 536Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const RoundedFilledPrivacyTip = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.18-280q16.22 0 26.02-9.92 9.8-9.93 9.8-26.08v-191q0-15.15-9.98-25.58-9.97-10.42-26.2-10.42-16.22 0-26.02 10.42Q444-522.15 444-507v191q0 16.15 9.98 26.08 9.97 9.92 26.2 9.92ZM480-591q19.83 0 32.41-13.09Q525-617.17 525-637q0-18.83-12.59-31.91Q499.83-682 480-682t-32.41 13.09Q435-655.83 435-637q0 19.83 12.59 32.91Q460.17-591 480-591Zm0 531q-8.32 0-15.88-1.5Q456.56-63 450-66q-144-47-229.5-177.5T135-523.11V-712q0-30.26 16.38-55.16Q167.75-792.07 196-802l251-94q16-6 33-6t33 6l251 94q28.25 9.93 45.13 34.84Q826-742.26 826-712v188.89Q826-374 740-243.5T510-66q-6.56 3-14.12 4.5T480-60Z" })
});
const RoundedPrivacyTip = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.18-280q16.22 0 26.02-9.92 9.8-9.93 9.8-26.27V-507q0-15.3-9.98-25.65-9.97-10.35-26.2-10.35-16.22 0-26.02 10.35T444-507v190.81q0 16.34 9.98 26.27 9.97 9.92 26.2 9.92ZM480-591q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm0 531q-8.32 0-15.88-1.5Q456.56-63 450-66q-144-47-229.5-177.6Q135-374.19 135-523.11V-712q0-30.26 16.38-55.16Q167.75-792.07 196-802l251-94q16-6 33-6t33 6l251 94q28.25 9.93 45.13 34.84Q826-742.26 826-712v188.89q0 148.92-86 279.51Q654-113 510-66q-6.56 3-14.12 4.5T480-60Zm0-91q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const SharpFilledPrivacyTip = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M444-280h72v-263h-72v263Zm36-311q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm-.06 536Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Z" })
});
const SharpPrivacyTip = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M444-280h72v-263h-72v263Zm36-311q19.83 0 32.41-13.22Q525-617.45 525-637q0-19.13-12.59-32.06Q499.83-682 480-682t-32.41 13.08Q435-655.84 435-636.51q0 19.34 12.59 32.42Q460.17-591 480-591Zm-.06 536Q329.1-92.81 232.05-227.41 135-362.01 135-522.67v-255.79L480-907l346 128.57V-523q0 160.79-97.62 295.49Q630.77-92.81 479.94-55Zm.06-96q110-43 180.5-144T731-522.71V-712l-251-95-251 95.48v188.35Q229-396 299.5-295 370-194 480-151Zm0-328Z" })
});
const componentMap = {
	outlined: OutlinedPrivacyTip,
	"outlined-fill": OutlinedFilledPrivacyTip,
	rounded: RoundedPrivacyTip,
	"rounded-fill": RoundedFilledPrivacyTip,
	sharp: SharpPrivacyTip,
	"sharp-fill": SharpFilledPrivacyTip
};
const IconPrivacyTip = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconPrivacyTip };